import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PromptService {

  private promptUpdateSubject = new Subject<{ tag: string; content: any; reportId: number }>();

  // Observable for components to subscribe to
  promptUpdate$ = this.promptUpdateSubject.asObservable();

  // Notify subscribers about prompt updates with report ID for filtering
  notifyPromptUpdate(tag: string, content: any, reportId: number): void {
    this.promptUpdateSubject.next({ tag, content, reportId });
  }

}
